/**
 * Copy of the trust pages (web plan W3.7): About, Contact, How we verify
 * deals, For businesses — global pages at `/about`, `/contact`,
 * `/how-we-verify` and `/for-businesses` (master plan D-2).
 *
 * Pure data (no `window`, no React): the pages, the footer and the SEO
 * server's route table read it through @/seo/trustPages.
 */

/** One trust page's copy. */
export interface TrustCopy {
  /**
   * The search-result snippet, at most 160 characters (longer text is cut at
   * a word). Optional: when empty, the page's first paragraph is used.
   */
  description: string;
  /**
   * The page text. Paragraphs are separated by a blank line; a paragraph that
   * starts with "## " is a subheading. Plain text only (no HTML, no links).
   */
  body: string;
}

export type TrustPageKey = 'about' | 'contact' | 'howWeVerify' | 'forBusinesses';

/**
 * OWNER CONTENT: original copy for each trust page (web plan "What I need"
 * #2, master §4 #13).
 *
 * Empty until the owner writes it. While a page's `body` is empty the page
 * does not exist: its URL shows the normal "Page not found" page (`noindex`,
 * HTTP 404 from the SEO server) and the footer does not link it. Filling a
 * `body` publishes the page — with its title, description and canonical from
 * the server — and adds it to the footer's Company links. The Contact page
 * also needs the contact email (`SITE_CONTACT_EMAIL` in ./site.ts): a contact
 * page without an address stays off.
 *
 * Never fill it with placeholder or generated text: nothing fake ever goes
 * live. The titles ("About PromoStork", "How We Verify Deals", …) are fixed
 * (the i18n catalogue's `trust` namespace).
 */
export const TRUST_COPY: Readonly<Record<TrustPageKey, TrustCopy>> = {
  about: { description: '', body: '' },
  contact: { description: '', body: '' },
  howWeVerify: { description: '', body: '' },
  forBusinesses: { description: '', body: '' },
};
